import './App.scss';
import Routes from './routes/Routes';
import {BrowserRouter} from 'react-router-dom';

function App() {
  return (
      <div className="App">
        <BrowserRouter>
          <Routes/>
        </BrowserRouter>
      </div>
  );
}

export default App;
